import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { HiOutlineAcademicCap } from "react-icons/hi";
import { RiPsychotherapyLine } from "react-icons/ri";

import DilipImg from "../../cms-ghost-app/ug_webinar/images/Dilip.webp";
import AkshayImg from "../../cms-ghost-app/ug_webinar/images/Akshay.webp";
import HarpreetImg from "../../cms-ghost-app/ug_webinar/images/harpreet.webp";
import PreetiImg from "../../cms-ghost-app/ug_webinar/images/preeti.webp";
import Nidhi from "../../cms-ghost-app/ug_webinar/images/Nidhi.webp";
import Eshan from "../../cms-ghost-app/ug_webinar/images/Eshan.webp";
import NirmalImg from "../../cms-ghost-app/ug_webinar/images/Nirmal.webp";
import KoustubhImg from "../../cms-ghost-app/ug_webinar/images/Koustubh.webp";
import MachaudharyImg from "../../cms-ghost-app/ug_webinar/images/Machaudhary.webp";
import NinoImg from "../../cms-ghost-app/ug_webinar/images/Nino.webp";
import GochaImg from "../../cms-ghost-app/ug_webinar/images/gocha.webp";
import Tamar from "../../cms-ghost-app/ug_webinar/images/Tamar.webp";
import TamarZeImg from "../../cms-ghost-app/ug_webinar/images/TamarZe.webp";
import DrAzamiImg from "../../cms-ghost-app/ug_webinar/images/DrAzami.webp"


const speakers = [
  {
    id: 1,
    name: "Mr. Nirmal Vaishnav",
    role: "Founder & CEO NeetSupport",
    degree: "MBA, JNU",
    image: NirmalImg,
    description:
      "Mr. Nirmal Vaishnav has positively impacted thousands of NEET aspirants and guided numerous students to their dream medical colleges. Visionary counsellor and founder of NEET Support. A strong believer of guidance and Indian medical education system. Working on building a team that brings positive change in counselling India.",
  },
  //   {
  //     id: 8,
  //     name: "Mr. Koustubh Pal",
  //     role: "Counselling & Guidance Expert",
  //     degree: "B.Tech (Computer Science), AKTU",
  //     image: KoustubhImg,
  //     description:
  //       "Mr. Koustubh Pal is dedicated to providing clear, step-by-step counselling and guidance for NEET aspirants and their parents. He helps students understand the counselling process, avoid common mistakes, and make informed decisions to achieve the best possible outcomes in their medical career journey.",
  //   },
  {
    id: 8,
    name: "Nino Pataraia",
    role: "Deputy Dean for Academic Affairs",
    degree: "European University, Georgia",
    image: NinoImg,
    description:
      "Nino Pataraia is the Deputy Dean for Academic Affairs at European University, Georgia. She plays an important role in academic planning, student support, and institutional coordination, helping students understand the academic environment and opportunities available at the university.",
  },
  {
    id: 7,
    name: "Dr. Dilip Kumar",
    role: "Professor & HoD, Microbiology",
    degree: "MBBS,MD, Sharda University",
    image: DilipImg,
    description:
      "Dr. Dilip is a senior academician and medical microbiologist with over 33 years of experience, currently serving as Professor & Head, Department of Microbiology, SMS&R. He is actively involved in academics and has played a key role in implementing Competency-Based Medical Education (CBME). A distinguished researcher with 103 scientific publications, Dr. Dilip has led and contributed to multiple ICMR, NCDC, NIV-CDC, and SKIMS-sponsored projects in infectious diseases, virology, and antimicrobial resistance. He is a member of several prestigious national and international professional bodies and serves on editorial boards and as a reviewer for multiple reputed journals. He is also a member of the Expert Working Group on the National Viral Hepatitis Surveillance Programme, contributing significantly to public health policy and disease surveillance in India.",
  },
  //   {
  //     id: 2,
  //     name: "Dr. Akshay Sharma",
  //     role: "Sr. Consultant & Asst. Director, Cardiac Surgery",
  //     degree: "MBBS, MS, MCh, JNU Medical College & Hospital",
  //     image: AkshayImg,
  //     description:
  //       "Dr. Akshay Sharma is a Senior Consultant and Assistant Director, Cardiac Surgery, currently associated with JNU Medical College & Hospital. He holds MBBS, MS, and MCh qualifications and has extensive expertise in cardiac and cardiothoracic surgery. With a strong focus on advanced surgical care, clinical excellence, and academic involvement, he plays a key role in delivering high-quality cardiac services and mentoring medical professionals.",
  //   },
  {
    id: 9,
    name: "Tamar Zarginava",
    role: "Vice-President",
    degree: "European University, Georgia",
    image: TamarZeImg,
    description:
      "Tamar Zarginava serves as Vice-President at European University, Georgia. She is actively involved in institutional leadership, international collaboration, and student-focused academic development, supporting the university’s mission of quality medical education.",
  },
  {
    id: 3,
    name: "Dr. Harpreet Singh",
    role: "Medical Superintendent",
    degree: "MBBS, MS , Geetanjali Medical College & Hospital",
    image: HarpreetImg,
    description:
      "Harpreet Singh is an experienced academic and healthcare professional with over 20 years of teaching experience, associated with Geetanjali Hospital, a tertiary care super-speciality teaching hospital attached to the NMC-recognised Geetanjali Medical College. He is actively involved in advancing quality healthcare delivery through skilled faculty, world-class infrastructure, and a strong commitment to patient care, contributing to the institution’s vision of excellence at national and international levels.",
  },
  {
    id: 10,
    name: "Gocha Tutberidze",
    role: "Rector",
    degree: "European University, Georgia",
    image: GochaImg,
    description:
      "Gocha Tutberidze is the director of European University, Georgia. With a strong leadership role in higher education, he contributes to academic excellence, institutional growth, and the development of globally oriented medical education for students.",
  },
  {
    id: 4,
    name: "Dr. Preeti Singh",
    role: "Principal Director General (Board)",
    degree: "BDS (Bachelor of Dental Surgery)\nMDS – Public Health Dentistry , G R Medical College, Gwalior",
    image: PreetiImg,
    description:
      "Dr. Preeti Singh is a qualified medical professional and serial entrepreneur with extensive experience in healthcare, diagnostics, and pharmaceutical product distribution. As a Whole-Time Director at Rama Group, she actively oversees day-to-day operations and strategic management. She has played a key role in building a nationwide diagnostic clinical chain focused on affordable, high-quality healthcare. Dr. Preeti is also instrumental in strengthening paramedical education by integrating quality training programs with university curricula, while optimizing operational efficiency and promoting social healthcare initiatives.",
  },
  //   {
  //     id: 5,
  //     name: "Dr. Eshan Sharma",
  //     role: "Prof. Medicine & Director as well as a director in hospital.",
  //     degree: "MBBS, MD,NIMS Jaipur Medical College & Hospital",
  //     image: Eshan,
  //     description:
  //       "Dr. Eshan Sharma is a distinguished Professor of Medicine and Director, currently serving at NIMS Jaipur Medical College & Hospital. He holds MBBS and MD degrees and specializes in General Medicine / Internal Medicine. With extensive academic and clinical experience, he is actively involved in patient care, medical education, and hospital administration, contributing significantly to quality healthcare delivery and the training of future medical professionals.",
  //   },
  {
    id: 11,
    name: "Tamar Pertaia",
    role: "Faculty Dean",
    degree: "Central University of Europe",
    image: Tamar,
    description:
      "Tamar Pertaia is the Faculty Dean at Central University of Europe. She supports academic leadership, faculty coordination, and student development, helping maintain strong academic standards and a supportive learning environment.",
  },
  {
    id: 6,
    name: "Dr. Nidhi Sharma",
    role: "Assistant Professor",
    degree: "MBBS, MD (Dermatology), NIMS",
    image: Nidhi,
    description:
      "Dr. Nidhi Sharma is an Assistant Professor with qualifications MBBS and MD (Dermatology). She specializes in Dermatology, Skin & VD, Venereology, Leprosy, and Sexually Transmitted Diseases (STD). With strong clinical and academic expertise, she is actively involved in patient care, teaching, and the diagnosis and management of a wide range of dermatological and venereal conditions.",
  },

  {
    id: 13,
    name: "Dr. Azmi",
    role: "CEO, Medicos Mindz",
    degree: "Medicos Mindz",
    image: DrAzamiImg,
    description:
      "Dr. Azmi is the CEO of Medicos Mindz and a dedicated mentor for medical aspirants. With strong experience in medical education guidance, counselling support, and student mentoring, he helps NEET aspirants and parents understand admission opportunities, counselling strategy, college selection, and career planning. His guidance focuses on helping students make informed decisions for their medical journey in India and abroad.",
  },


  {
    id: 12,
    name: "Dr. M. A. Chaudhary",
    role: "CEO EEL & Manager of Selection and Admission of Foreign Students of CUE",
    degree: "Central University of Europe",
    image: MachaudharyImg,
    description:
      "Dr. M. A. Chaudhary is the CEO of EEL and Manager of Selection and Admission of Foreign Students of Central University of Europe. He plays a key role in guiding international students through selection, admission, and academic transition processes.",
  },
];

const SpeakerModal = ({ speaker, isOpen, onClose }) => {
  if (!isOpen || !speaker) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      {/* Modal Content */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-gray-200">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 bg-gray-700 hover:bg-gray-800 rounded-full flex items-center justify-center transition-colors z-20 shadow-lg"
        >
          <IoClose size={18} className="text-white" />
        </button>

        {/* Speaker Image & Name */}
        <div className="text-center pt-8 pb-4 px-6">
          <div className="inline-block p-1 rounded-full bg-gradient-to-b from-[#ffd700] to-[#ffb347] mb-4">
            <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-full overflow-hidden bg-[#fff8dc] p-1">
              <img
                src={speaker.image?.src || speaker.image}
                alt={speaker.name}
                className="w-full h-full object-cover rounded-full"
              />
            </div>
          </div>

          <h3 className="text-lg sm:text-xl font-bold text-gray-900">
            {speaker.name}
          </h3>

          <div className="w-20 h-0.5 bg-gradient-to-r from-[#ff9245] to-[#ffb366] mx-auto mt-2 mb-2" />
          <p className="text-gray-500 text-sm">{speaker.role}</p>
        </div>

        {/* Degrees */}
        <div className="px-5 py-4">
          <div className="flex items-center gap-4 p-4 bg-[#fffbeb] rounded-xl border border-[#fef3c7]">
            <div className="w-12 h-12 bg-[#fff5eb] rounded-xl flex items-center justify-center flex-shrink-0 border border-[#ffe4cc]">
              <HiOutlineAcademicCap className="text-[#ff9245] w-6 h-6" />
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-medium whitespace-pre-line">
                {speaker.degree}
              </span>
            </div>
          </div>
        </div>

        {/* Description */}
        <div className="px-5 pb-6">
          <div className="flex gap-3 p-4 bg-[#f0f9ff] rounded-xl border border-[#e0f2fe] mb-4">
            <p className="text-sm text-gray-600 leading-relaxed flex-1">
              {speaker.description}
            </p>
            <div className="w-12 h-12 bg-[#fef9c3] rounded-xl flex items-center justify-center flex-shrink-0 self-end border border-[#fef08a]">
              <RiPsychotherapyLine className="text-[#f59e0b] w-6 h-6" />
            </div>
          </div>
          {/* Add a visible border below the description area */}
          <div className="w-full h-0.5 bg-gradient-to-r from-[#ff9245] to-[#ffb366] rounded-b-xl" />
        </div>
      </div>
    </div>
  );
};

const SpeakerCard = ({ speaker, onClick }) => {
  // Split degree by comma, last part is college name
  const degreeParts = speaker.degree.split(',');
  const mainDegree = degreeParts.slice(0, -1).join(',').trim();
  const collegeName = degreeParts.length > 1 ? degreeParts[degreeParts.length - 1].trim() : '';

  return (
    <div
      className="speaker-card relative bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer"
      style={{ minHeight: '220px', height: '220px', display: 'flex', flexDirection: 'column' }}
      onClick={onClick}
    >
      {/* Orange gradient background on right side */}
      <div
        className="absolute right-0 top-0 bottom-0 w-2/5"
        style={{
          background: "linear-gradient(135deg, #fff8f0 0%, #ffe8d4 100%)",
        }}
      />

      <div className="relative flex h-full min-h-[180px] sm:min-h-[200px] flex-1">
        {/* Content */}
        <div className="flex-1 p-4 sm:p-5 z-10 flex flex-col justify-between">
          <div>
            <h3 className="text-base sm:text-lg font-bold text-gray-900 mb-1">
              {speaker.name}
            </h3>
            <p className="text-gray-500 text-xs sm:text-sm mb-3 line-clamp-2 leading-relaxed">
              {speaker.role}
            </p>

            <div className="inline-block bg-[#fff5eb] border border-[#ffe4cc] rounded-md px-2 py-1 mb-3">
              <p className="text-[10px] sm:text-xs font-semibold text-[#ff9245]">
                {mainDegree || speaker.degree}
                {collegeName && (
                  <span className="text-[#2563eb] font-normal"> ({collegeName})</span>
                )}
              </p>
            </div>
          </div>

          {/* Read More */}
          <div>
            <button className="inline-flex items-center gap-2 text-sm text-gray-700 hover:text-[#ff9245] transition-colors font-medium">
              Read more
              <FaArrowRight size={12} />
            </button>
          </div>
        </div>

        {/* Image */}
        <div className="relative w-32 sm:w-36 md:w-40 flex-shrink-0">
          <img
            src={speaker.image?.src || speaker.image}
            alt={speaker.name}
            className="speaker-img absolute inset-0 h-full w-full object-cover object-top"
          />
        </div>
      </div>
    </div>
  );
};

export default function OurSpeaker() {
  const [selectedSpeaker, setSelectedSpeaker] = useState(null);

  useEffect(() => {
    if (selectedSpeaker) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "unset";

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [selectedSpeaker]);

  const openModal = (speaker) => setSelectedSpeaker(speaker);
  const closeModal = () => setSelectedSpeaker(null);

  return (
    <>
      <section
        className="w-full bg-white py-4 sm:py-12 md:py-16 transition-all duration-300"
        style={{ filter: selectedSpeaker ? "blur(1px)" : "none" }}
      >
        <div className="mx-auto max-w-7xl px-3 sm:px-4 md:px-6">
          {/* Header */}
          <div className="text-center mb-6 sm:mb-8 md:mb-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">
              Overall <span className="text-[#ff9245]">Speakers</span>
            </h2>
            <p className="mt-2 sm:mt-3 text-xs sm:text-sm md:text-base text-gray-600 px-2">
              Learn counselling strategy and college selection from experienced experts
            </p>
          </div>

          {/* Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6 max-w-6xl mx-auto">
            {speakers.map((speaker) => (
              <SpeakerCard
                key={speaker.id}
                speaker={speaker}
                onClick={() => openModal(speaker)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      <SpeakerModal
        speaker={selectedSpeaker}
        isOpen={!!selectedSpeaker}
        onClose={closeModal}
      />
    </>
  );
}
